@if (applicationType !== 'ccps') {
  <h2>FTP questions</h2>
}
@if (applicationType === 'ccps') {
  <h5>FTP questions</h5>
}
<div>
  @for (question of application.ftpQuestions; track question) {
    <app-declaration-question  [question]="question" [readonly]="true">
    </app-declaration-question>
  }

</div>